<div class="roles-container">
  <div class="header-actions">
    <h2>Role Permissions Management</h2>
    <div class="button-group">
      <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="primary" (click)="showPermissionsModal()">
        <span nz-icon nzType="setting"></span>
        Manage Permissions
      </button>
      <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="primary" (click)="showAddRoleModal()">
        <span nz-icon nzType="plus"></span>
        Add New Role
      </button>
    </div>

    <nz-form-item class="floatL" style="width: 50%;"
      *ngIf="hasPermissions('view_distributor_documents') || hasPermissions('view_all_documents')">
      <nz-form-label>Company</nz-form-label>
      <nz-select nzShowSearch [(ngModel)]="selectedCompany" style="width: 100%;" (ngModelChange)="getRolesByCompany()">
        <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
      </nz-select>
    </nz-form-item>

  </div>

  <nz-table #rolesTable [nzData]="roles" [nzLoading]="isLoading">
    <thead>
      <tr>
        <th>Role Name</th>
        <th>Description</th>
        <th>Current Permissions</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let role of rolesTable.data">
        <td>{{ role.name | titlecase }}</td>
        <td>{{ role.description }}</td>
        <td>
          <nz-tag *ngFor="let permission of role.permissions">
            {{ permission.name | titlecase }}
          </nz-tag>
        </td>
        <td>
          <div class="action-buttons">
            <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="primary"
              (click)="showPermissionModal(role)">
              Permissions
            </button>
            <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="default"
              (click)="showEditRoleModal(role)">
              Edit
            </button>
            <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="primary" nzDanger
              (click)="confirmDeleteRole(role.id)">
              Delete
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- Add Role Modal -->
  <nz-modal [(nzVisible)]="isAddRoleModalVisible" nzTitle="Create New Role" (nzOnCancel)="isAddRoleModalVisible = false"
    (nzOnOk)="handleAddRole()" [nzOkLoading]="isLoading" [nzCancelDisabled]="isLoading">
    <ng-container *nzModalContent>
      <form [formGroup]="roleForm" nz-form>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Role Name</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="Please enter a valid role name (min 2 characters)">
            <input nz-input formControlName="name" placeholder="Enter role name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea nz-input formControlName="description" placeholder="Enter role description"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }">
              </textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Initial Permissions</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select formControlName="permissions" nzMode="multiple" nzPlaceHolder="Select permissions"
              [nzOptions]="permissionOptions">
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>

  <!-- Permissions Modal -->
  <nz-modal [(nzVisible)]="isModalVisible" [nzTitle]="'Manage Permissions for ' + (selectedRole?.name || '')"
    (nzOnCancel)="isModalVisible = false" (nzOnOk)="saveRolePermissions()" [nzWidth]="720" [nzOkLoading]="isLoading"
    [nzCancelDisabled]="isLoading">
    <ng-container *nzModalContent>
      <div class="permissions-grid">
        <nz-tabset>
          <nz-tab *ngFor="let module of getUniqueModules()" [nzTitle]="module | titlecase">
            <div class="permission-list">
              <div *ngFor="let permission of getPermissionsByModule(module)" class="permission-item">
                <label nz-checkbox [nzChecked]="hasPermission(permission)"
                  (nzCheckedChange)="togglePermission(permission)" [nzDisabled]="!hasPermissions('manage_permissions')">
                  <span class="permission-name">{{ permission.name | titlecase }}</span>
                  <span class="permission-description">
                    {{ permission.description }}
                  </span>
                  <span *ngIf="superAdminOnly(permission)" class="super-admin-badge"
                    class="permission-restricted">
                    (Super Admin Only)
                  </span>
                </label>
              </div>
            </div>
          </nz-tab>
        </nz-tabset>
      </div>
    </ng-container>
  </nz-modal>

  <!-- Add Permission Modal -->
  <nz-modal [(nzVisible)]="isAddPermissionModalVisible" nzTitle="Create New Permission"
    (nzOnCancel)="isAddPermissionModalVisible = false" (nzOnOk)="handleAddPermission()" [nzOkLoading]="isLoading"
    [nzCancelDisabled]="isLoading">
    <ng-container *nzModalContent>
      <form [formGroup]="permissionForm" nz-form>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Name</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="Please enter a valid permission name (min 2 characters)">
            <input nz-input formControlName="name" placeholder="Enter permission name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Module</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select formControlName="module" nzPlaceHolder="Select module" [nzShowSearch]="true">
              <nz-option *ngFor="let module of getUniqueModules()" [nzValue]="module"
                [nzLabel]="module | titlecase"></nz-option>
              <nz-option nzValue="_new" nzLabel="Add New Module"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="isNewModule">
          <nz-form-label [nzSpan]="6" nzRequired>New Module</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <input nz-input formControlName="newModule" placeholder="Enter new module name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea nz-input formControlName="description" placeholder="Enter permission description"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }">
              </textarea>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>

  <!-- Permissions Management Modal -->
  <nz-modal [(nzVisible)]="isPermissionsModalVisible" nzTitle="Permissions Management"
    (nzOnCancel)="isPermissionsModalVisible = false" [nzFooter]="null" [nzWidth]="900">
    <ng-container *nzModalContent>
      <div class="permissions-header">
        <button *ngIf="currentUser?.super_admin" nz-button nzType="primary" (click)="showAddPermissionModal()">
          <span nz-icon nzType="plus"></span>
          Add New Permission
        </button>
      </div>

      <nz-tabset>
        <nz-tab *ngFor="let module of getUniqueModules()" [nzTitle]="module | titlecase">
          <nz-table #permissionsTable [nzData]="getPermissionsByModule(module)" [nzPageSize]="10">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let permission of permissionsTable.data">
                <td>
                  {{ permission.name }}
                  <span *ngIf="superAdminOnly(permission)" class="super-admin-badge">
                    (Super Admin Only)
                  </span>
                </td>
                <td>{{ permission.description }}</td>
                <td>
                  <div class="action-buttons">
                    <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="default"
                      (click)="showEditPermissionModal(permission)">
                      Edit
                    </button>
                    <button *ngIf="hasPermissions('manage_permissions')" nz-button nzType="primary" nzDanger
                      (click)="confirmDeletePermission(permission)">
                      Delete
                    </button>
                    <span *ngIf="!hasPermissions('manage_permissions')" class="restricted-text">
                      Restricted
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-tab>
      </nz-tabset>
    </ng-container>
  </nz-modal>

  <!-- Add Edit Role Modal -->
  <nz-modal [(nzVisible)]="isEditRoleModalVisible" nzTitle="Edit Role" (nzOnCancel)="isEditRoleModalVisible = false"
    (nzOnOk)="handleEditRole()" [nzOkLoading]="isLoading" [nzCancelDisabled]="isLoading">
    <ng-container *nzModalContent>
      <form [formGroup]="roleForm" nz-form>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Role Name</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="Please enter a valid role name (min 2 characters)">
            <input nz-input formControlName="name" placeholder="Enter role name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea nz-input formControlName="description" placeholder="Enter role description"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }">
              </textarea>
          </nz-form-control>
        </nz-form-item>

        <!-- <nz-form-item>
            <nz-form-label [nzSpan]="6">Initial Permissions</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-select
                formControlName="permissions"
                nzMode="multiple"
                nzPlaceHolder="Select permissions"
                [nzOptions]="permissionOptions"
              >
              </nz-select>
            </nz-form-control>
          </nz-form-item> -->
      </form>
    </ng-container>
  </nz-modal>

  <!-- Add Edit Permission Modal -->
  <nz-modal [(nzVisible)]="isEditPermissionModalVisible" nzTitle="Edit Permission"
    (nzOnCancel)="isEditPermissionModalVisible = false" (nzOnOk)="handleEditPermission()" [nzOkLoading]="isLoading"
    [nzCancelDisabled]="isLoading">
    <ng-container *nzModalContent>
      <form [formGroup]="permissionForm" nz-form>
        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Name</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="Please enter a valid permission name (min 2 characters)">
            <input nz-input formControlName="name" placeholder="Enter permission name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6" nzRequired>Module</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select formControlName="module" nzPlaceHolder="Select module" [nzShowSearch]="true">
              <nz-option *ngFor="let module of getUniqueModules()" [nzValue]="module"
                [nzLabel]="module | titlecase"></nz-option>
              <nz-option nzValue="_new" nzLabel="Add New Module"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item *ngIf="isNewModule">
          <nz-form-label [nzSpan]="6" nzRequired>New Module</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <input nz-input formControlName="newModule" placeholder="Enter new module name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Description</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <textarea nz-input formControlName="description" placeholder="Enter permission description"
              [nzAutosize]="{ minRows: 3, maxRows: 5 }">
              </textarea>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>